// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Image$ReactHooksTemplate = require("./common/image.res.js");
var Utils$ReactHooksTemplate = require("./common/utils.res.js");
var Filters$ReactHooksTemplate = require("./dashboard/filters/filters.res.js");
var MomentRe$ReactHooksTemplate = require("./MomentRe.res.js");
var Pagination$ReactHooksTemplate = require("./common/Pagination.res.js");
var PaginationUtils$ReactHooksTemplate = require("./common/PaginationUtils.res.js");

var categoryList = {
  hd: "Agent Related::Lack Agent Etiquette",
  tl: {
    hd: "Agent Related::Need To Provide Proper Information",
    tl: {
      hd: "Agent Related::Should Speak Politely",
      tl: {
        hd: "B1w Issue",
        tl: {
          hd: "Balance Deduction",
          tl: {
            hd: "Better Offers And Services",
            tl: {
              hd: "Cgt Issue",
              tl: {
                hd: "Comment Namilekaharu",
                tl: {
                  hd: "Contact Center Related",
                  tl: {
                    hd: "Contact Center Related::Direct Call Transfer To Operator",
                    tl: {
                      hd: "Contact Center Related::Multilingual",
                      tl: {
                        hd: "Contact Center Related::Quick Response",
                        tl: {
                          hd: "Contact Center Related::Quick Solution",
                          tl: {
                            hd: "Dissatisfied Customer",
                            tl: {
                              hd: "Expand Network",
                              tl: {
                                hd: "Free Offers And Services",
                                tl: {
                                  hd: "Implement 4g Services",
                                  tl: {
                                    hd: "Improve Network",
                                    tl: {
                                      hd: "More Offers And Services",
                                      tl: {
                                        hd: "N/A",
                                        tl: {
                                          hd: "Ncell Center Related::Dissatisfied Customer",
                                          tl: {
                                            hd: "Ncell Center Related::More Centers",
                                            tl: {
                                              hd: "No Match Found",
                                              tl: {
                                                hd: "Others",
                                                tl: {
                                                  hd: "Others::Auto Activation Of Services",
                                                  tl: {
                                                    hd: "Others::Drc Issue",
                                                    tl: {
                                                      hd: "Others::Service Issue",
                                                      tl: {
                                                        hd: "Others::Service Issues",
                                                        tl: {
                                                          hd: "Others::Service Queries",
                                                          tl: {
                                                            hd: "Others::Sim Recycle Issue",
                                                            tl: {
                                                              hd: "Product Enhancement Suggestions",
                                                              tl: {
                                                                hd: "Product Enhancement Suggestions::Data Transfer Service",
                                                                tl: {
                                                                  hd: "Product Enhancement Suggestions::Instant Data Pack End Notification",
                                                                  tl: {
                                                                    hd: "Product Enhancement Suggestions::More Offers For Postpaid",
                                                                    tl: {
                                                                      hd: "Product Enhancement Suggestions::Postpaid To Prepaid Conversion",
                                                                      tl: {
                                                                        hd: "Product Enhancement Suggestions::Provide Bonus",
                                                                        tl: {
                                                                          hd: "Product Enhancement Suggestions::Revise Data Pack",
                                                                          tl: {
                                                                            hd: "Product Enhancement Suggestions::Revise Loan Service",
                                                                            tl: {
                                                                              hd: "Product Enhancement Suggestions::Revise Voice Pack",
                                                                              tl: {
                                                                                hd: "Product Enhancement Suggestions::Service Deactivation Process",
                                                                                tl: {
                                                                                  hd: "Reduce Tariff",
                                                                                  tl: {
                                                                                    hd: "Retail Channel Related::Photo Copy Issue",
                                                                                    tl: {
                                                                                      hd: "Retail Channel Related::Quick Sim Activation",
                                                                                      tl: {
                                                                                        hd: "Satisfied Customer",
                                                                                        tl: {
                                                                                          hd: "Tsc Issue",
                                                                                          tl: {
                                                                                            hd: "Unlimited Offers And Services",
                                                                                            tl: /* [] */0
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function id(t) {
  return t.id;
}

function msisdn(t) {
  return t.msisdn;
}

function lob(t) {
  return t.lob;
}

function shopName(t) {
  return t.shopName;
}

function status(t) {
  return t.status;
}

function longTextResponse(t) {
  return t.longTextResponse;
}

function sentiment(t) {
  return t.sentiment;
}

function triggerDate(t) {
  return t.triggerDate;
}

function categories(t) {
  return t.categories;
}

function edited(t) {
  return t.edited;
}

function lastEditedAt(t) {
  return t.lastEditedAt;
}

function lastEditedBy(t) {
  return t.lastEditedBy;
}

function setCategories(categories, t) {
  return {
          id: t.id,
          msisdn: t.msisdn,
          lob: t.lob,
          shopName: t.shopName,
          status: t.status,
          triggerDate: t.triggerDate,
          longTextResponse: t.longTextResponse,
          sentiment: t.sentiment,
          categories: categories,
          edited: t.edited,
          lastEditedAt: t.lastEditedAt,
          lastEditedBy: t.lastEditedBy
        };
}

function setEdited(edited, t) {
  return {
          id: t.id,
          msisdn: t.msisdn,
          lob: t.lob,
          shopName: t.shopName,
          status: t.status,
          triggerDate: t.triggerDate,
          longTextResponse: t.longTextResponse,
          sentiment: t.sentiment,
          categories: t.categories,
          edited: edited,
          lastEditedAt: t.lastEditedAt,
          lastEditedBy: t.lastEditedBy
        };
}

function setSentiment(sentiment, t) {
  return {
          id: t.id,
          msisdn: t.msisdn,
          lob: t.lob,
          shopName: t.shopName,
          status: t.status,
          triggerDate: t.triggerDate,
          longTextResponse: t.longTextResponse,
          sentiment: sentiment,
          categories: t.categories,
          edited: t.edited,
          lastEditedAt: t.lastEditedAt,
          lastEditedBy: t.lastEditedBy
        };
}

function fromJson(json) {
  return {
          id: Json_decode.field("response_id", Json_decode.$$int, json),
          msisdn: Json_decode.optional((function (param) {
                  return Json_decode.field("msisdn", Json_decode.string, param);
                }), json),
          lob: Json_decode.optional((function (param) {
                  return Json_decode.field("lob", Json_decode.string, param);
                }), json),
          shopName: Json_decode.optional((function (param) {
                  return Json_decode.field("shop_name", Json_decode.string, param);
                }), json),
          status: Json_decode.field("status", Json_decode.string, json),
          triggerDate: MomentRe$ReactHooksTemplate.moment(undefined, Json_decode.field("trigger_date", Json_decode.string, json)),
          longTextResponse: Json_decode.field("long_text_response", Json_decode.string, json),
          sentiment: Json_decode.field("sentiment", Json_decode.string, json),
          categories: Json_decode.field("categories", (function (param) {
                  return Json_decode.list(Json_decode.string, param);
                }), json),
          edited: Json_decode.field("edited", Json_decode.bool, json),
          lastEditedAt: Belt_Option.map(Json_decode.field("last_edited_info", (function (param) {
                      return Json_decode.optional((function (json) {
                                    return Json_decode.field("updated_at", Json_decode.string, json);
                                  }), param);
                    }), json), (function (x) {
                  return MomentRe$ReactHooksTemplate.moment(undefined, x);
                })),
          lastEditedBy: Json_decode.field("last_edited_info", (function (param) {
                  return Json_decode.optional((function (json) {
                                return Json_decode.field("editor", (function (json) {
                                              return Json_decode.field("email", Json_decode.string, json);
                                            }), json);
                              }), param);
                }), json)
        };
}

var CategoryReport = {
  id: id,
  msisdn: msisdn,
  lob: lob,
  shopName: shopName,
  status: status,
  longTextResponse: longTextResponse,
  sentiment: sentiment,
  triggerDate: triggerDate,
  categories: categories,
  edited: edited,
  lastEditedAt: lastEditedAt,
  lastEditedBy: lastEditedBy,
  setCategories: setCategories,
  setEdited: setEdited,
  setSentiment: setSentiment,
  fromJson: fromJson
};

var initialState = {
  loading: true,
  filter: false,
  editCategory: undefined,
  categoryReport: /* [] */0,
  total: 1,
  perPage: 1
};

function CategoryEdit(props) {
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var queryParams = Querystringify.parse(props.params);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var page = Belt_Int.fromString(x);
    currentPage = page !== undefined ? page : 1;
  } else {
    currentPage = 1;
  }
  var x$1 = Js_dict.get(queryParams, "sortedCol");
  var sortedColumn = x$1 !== undefined && x$1 !== "" ? x$1 : undefined;
  var x$2 = Js_dict.get(queryParams, "sortOrder");
  var sortingOrder = x$2 !== undefined && x$2 !== "" ? x$2 : undefined;
  var initialSortingInfo = {
    sortedColumn: sortedColumn,
    sortingOrder: sortingOrder
  };
  var match$1 = React.useState(function (param) {
        return initialSortingInfo;
      });
  var setSortingInfo = match$1[1];
  var sortingInfo = match$1[0];
  var match$2 = React.useState(function (param) {
        return false;
      });
  var setOpenSortModal = match$2[1];
  var fetchCategoryReport = function (pageNo) {
    var match = sortingInfo.sortedColumn;
    var match$1 = sortingInfo.sortingOrder;
    var url = match !== undefined ? (
        match$1 !== undefined ? "/api/v1/campaign_reports/text_category_report?page=" + (String(pageNo) + ("&sort_column=" + (match + ("&sort_order=" + match$1)))) : "/api/v1/campaign_reports/text_category_report?page=" + String(pageNo)
      ) : "/api/v1/campaign_reports/text_category_report?page=" + String(pageNo);
    return Js_promise.then_((function (param) {
                  var headers = param[0];
                  var total = Caml_format.int_of_string(Belt_Option.getWithDefault(Caml_option.null_to_opt(headers.get("Total")), "1"));
                  var perPage = Caml_format.int_of_string(Belt_Option.getWithDefault(Caml_option.null_to_opt(headers.get("Per-Page")), "20"));
                  var report = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("report", (function (param) {
                                            return Json_decode.list(fromJson, param);
                                          }), json));
                        }), param[1]);
                  return Promise.resolve([
                              report,
                              [
                                total,
                                perPage
                              ]
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
  };
  var applySort = function (param) {
    var sortedCol = sortingInfo.sortedColumn;
    var sortOrder = sortingInfo.sortingOrder;
    RescriptReactRouter.push("/category_edit?page=1&sortedCol=" + Belt_Option.getWithDefault(sortedCol, "") + "&sortOrder=" + Belt_Option.getWithDefault(sortOrder, ""));
    Curry._1(setState, (function (state) {
            return {
                    loading: true,
                    filter: false,
                    editCategory: state.editCategory,
                    categoryReport: state.categoryReport,
                    total: state.total,
                    perPage: state.perPage
                  };
          }));
    Js_promise.then_((function (param) {
            var match = param[1];
            var perPage = match[1];
            var total = match[0];
            return Promise.resolve(Js_promise.then_((function (categoryReport) {
                              return Promise.resolve(Curry._1(setState, (function (state) {
                                                return {
                                                        loading: false,
                                                        filter: state.filter,
                                                        editCategory: state.editCategory,
                                                        categoryReport: categoryReport,
                                                        total: total,
                                                        perPage: perPage
                                                      };
                                              })));
                            }), param[0]));
          }), fetchCategoryReport(1));
  };
  var handlePageChange = function (pageNumber) {
    RescriptReactRouter.push("/category_edit?page=" + String(pageNumber));
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (param) {
                  var match = param[1];
                  var perPage = match[1];
                  var total = match[0];
                  return Promise.resolve(Js_promise.then_((function (categoryReport) {
                                    return Promise.resolve(Curry._1(setState, (function (state) {
                                                      return {
                                                              loading: false,
                                                              filter: state.filter,
                                                              editCategory: state.editCategory,
                                                              categoryReport: categoryReport,
                                                              total: total,
                                                              perPage: perPage
                                                            };
                                                    })));
                                  }), param[0]));
                }), fetchCategoryReport(currentPage));
        }), [currentPage]);
  var onApplyFilter = function (param) {
    if (currentPage > 1) {
      return RescriptReactRouter.push("/category_edit");
    } else {
      Curry._1(setState, (function (state) {
              return {
                      loading: true,
                      filter: false,
                      editCategory: state.editCategory,
                      categoryReport: state.categoryReport,
                      total: state.total,
                      perPage: state.perPage
                    };
            }));
      Js_promise.then_((function (param) {
              var match = param[1];
              var perPage = match[1];
              var total = match[0];
              return Promise.resolve(Js_promise.then_((function (categoryReport) {
                                return Promise.resolve(Curry._1(setState, (function (state) {
                                                  return {
                                                          loading: false,
                                                          filter: state.filter,
                                                          editCategory: state.editCategory,
                                                          categoryReport: categoryReport,
                                                          total: total,
                                                          perPage: perPage
                                                        };
                                                })));
                              }), param[0]));
            }), fetchCategoryReport(1));
      return ;
    }
  };
  if (state.loading) {
    return JsxRuntime.jsx("p", {
                children: "Loading..."
              });
  } else {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  state.filter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                          onClose: (function (param) {
                              Curry._1(setState, (function (state) {
                                      return {
                                              loading: state.loading,
                                              filter: false,
                                              editCategory: state.editCategory,
                                              categoryReport: state.categoryReport,
                                              total: state.total,
                                              perPage: state.perPage
                                            };
                                    }));
                            }),
                          onApply: onApplyFilter,
                          showDateFilter: false,
                          showFilterPills: false
                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("h2", {
                                        children: "Category Report",
                                        className: "text-xl font-semibold"
                                      }),
                                  JsxRuntime.jsxs("button", {
                                        children: [
                                          JsxRuntime.jsx("img", {
                                                className: "h-14-px mr-2-px",
                                                src: Image$ReactHooksTemplate.filterButton
                                              }),
                                          "Filters"
                                        ],
                                        className: "bg-ghostwhite border border-gray-400\n              shadow-inner flex rounded py-2 px-3 text-xs",
                                        id: "filters",
                                        onClick: (function (param) {
                                            Curry._1(setState, (function (state) {
                                                    return {
                                                            loading: state.loading,
                                                            filter: true,
                                                            editCategory: state.editCategory,
                                                            categoryReport: state.categoryReport,
                                                            total: state.total,
                                                            perPage: state.perPage
                                                          };
                                                  }));
                                          })
                                      })
                                ],
                                className: "flex justify-between items-center mb-30-px border-b border-gray-300 px-30-px py-16-px"
                              }),
                          JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                                currentPage: currentPage,
                                totalPages: PaginationUtils$ReactHooksTemplate.totalPages(state.total, state.perPage),
                                totalRecords: state.total,
                                perPage: state.perPage,
                                handlePageChange: handlePageChange,
                                itemLabel: "records",
                                className: "mx-30-px mb-4"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("table", {
                                      children: [
                                        JsxRuntime.jsx("thead", {
                                              children: JsxRuntime.jsxs("tr", {
                                                    children: [
                                                      JsxRuntime.jsxs("th", {
                                                            children: [
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "Trigger Date",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px sort-img",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex cursor-pointer",
                                                                    onClick: (function (param) {
                                                                        Curry._1(setOpenSortModal, (function (param) {
                                                                                return true;
                                                                              }));
                                                                      })
                                                                  }),
                                                              match$2[0] ? JsxRuntime.jsxs("div", {
                                                                      children: [
                                                                        JsxRuntime.jsx("div", {
                                                                              children: "Sort",
                                                                              className: "text-sm font-light text-aurometalsaurus"
                                                                            }),
                                                                        JsxRuntime.jsx("button", {
                                                                              children: "Sort by latest first",
                                                                              className: "w-48 flex flex-row justify-start items-center p-2 rounded " + (
                                                                                Belt_Option.getWithDefault(sortingInfo.sortedColumn, "") !== "trigger_date" || Belt_Option.getWithDefault(sortingInfo.sortingOrder, "") === "desc" ? "bg-lavenderweb border border-lavenderweb" : ""
                                                                              ),
                                                                              onClick: (function (param) {
                                                                                  Curry._1(setSortingInfo, (function (param) {
                                                                                          return {
                                                                                                  sortedColumn: "trigger_date",
                                                                                                  sortingOrder: "desc"
                                                                                                };
                                                                                        }));
                                                                                })
                                                                            }),
                                                                        JsxRuntime.jsx("button", {
                                                                              children: "Sort by oldest first",
                                                                              className: "w-48 flex flex-row justify-start items-center p-2 rounded " + (
                                                                                Belt_Option.getWithDefault(sortingInfo.sortedColumn, "") === "trigger_date" && Belt_Option.getWithDefault(sortingInfo.sortingOrder, "") === "asc" ? "bg-lavenderweb border border-lavenderweb" : ""
                                                                              ),
                                                                              onClick: (function (param) {
                                                                                  Curry._1(setSortingInfo, (function (param) {
                                                                                          return {
                                                                                                  sortedColumn: "trigger_date",
                                                                                                  sortingOrder: "asc"
                                                                                                };
                                                                                        }));
                                                                                })
                                                                            }),
                                                                        JsxRuntime.jsx("hr", {
                                                                              className: "border border-gray-200 w-full"
                                                                            }),
                                                                        JsxRuntime.jsxs("div", {
                                                                              children: [
                                                                                JsxRuntime.jsx("button", {
                                                                                      children: "Cancel",
                                                                                      className: "py-2 w-1/2 border border-gray-300 text-aurometalsaurus rounded",
                                                                                      onClick: (function (param) {
                                                                                          Curry._1(setOpenSortModal, (function (param) {
                                                                                                  return false;
                                                                                                }));
                                                                                        })
                                                                                    }),
                                                                                JsxRuntime.jsx("button", {
                                                                                      children: "Apply",
                                                                                      className: "py-2 w-1/2 bg-pigmentblue text-white rounded",
                                                                                      onClick: (function (param) {
                                                                                          applySort();
                                                                                          Curry._1(setOpenSortModal, (function (param) {
                                                                                                  return false;
                                                                                                }));
                                                                                        })
                                                                                    })
                                                                              ],
                                                                              className: "flex justify-between w-full font-semibold text-sm gap-2"
                                                                            })
                                                                      ],
                                                                      className: "flex border border-gray-400 rounded-lg shadow-md flex-col justify-start\n                          items-start gap-2 p-4 z-10 absolute bg-white"
                                                                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                            ],
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "MSISDN",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "LOB",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "SHOP NAME",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "OPEN COMMENT",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "LAST EDITED AT",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "LAST EDITED BY",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "SENTIMENT",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsxs("div", {
                                                                  children: [
                                                                    "CATEGORIES",
                                                                    JsxRuntime.jsx("img", {
                                                                          className: "ml-4-px",
                                                                          src: Image$ReactHooksTemplate.heading
                                                                        })
                                                                  ],
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          }),
                                                      JsxRuntime.jsx("th", {
                                                            children: JsxRuntime.jsx("div", {
                                                                  className: "flex"
                                                                }),
                                                            className: "px-4 py-2"
                                                          })
                                                    ]
                                                  }),
                                              className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                            }),
                                        JsxRuntime.jsx("tbody", {
                                              children: $$Array.of_list(List.map((function (x) {
                                                          var y = x.msisdn;
                                                          var lob = x.lob;
                                                          var y$1 = x.shopName;
                                                          var categoryReport = state.editCategory;
                                                          var categoryReport$1 = state.editCategory;
                                                          return JsxRuntime.jsxs("tr", {
                                                                      children: [
                                                                        JsxRuntime.jsx("td", {
                                                                              children: x.triggerDate.format("YYYY/MM/DD HH:MM:SS"),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: y !== undefined ? y : "-",
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: lob !== undefined ? lob : "-",
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: y$1 !== undefined ? y$1 : "-",
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: x.longTextResponse,
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: Belt_Option.mapWithDefault(x.lastEditedAt, "-", (function (y) {
                                                                                      return y.format("YYYY/MM/DD HH:MM:SS");
                                                                                    })),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: Belt_Option.getWithDefault(x.lastEditedBy, "-"),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    children: categoryReport !== undefined ? (
                                                                                        categoryReport.id === x.id ? JsxRuntime.jsxs("select", {
                                                                                                children: [
                                                                                                  JsxRuntime.jsx("option", {
                                                                                                        children: "Select Sentiment",
                                                                                                        disabled: true,
                                                                                                        value: "Select Sentiment"
                                                                                                      }, "0"),
                                                                                                  JsxRuntime.jsx("option", {
                                                                                                        children: "Positive",
                                                                                                        selected: "positive" === x.sentiment,
                                                                                                        value: "positive"
                                                                                                      }, "1"),
                                                                                                  JsxRuntime.jsx("option", {
                                                                                                        children: "Negative",
                                                                                                        selected: "Negative" === x.sentiment,
                                                                                                        value: "negative"
                                                                                                      }, "2"),
                                                                                                  JsxRuntime.jsx("option", {
                                                                                                        children: "Neutral",
                                                                                                        selected: "neutral" === x.sentiment,
                                                                                                        value: "neutral"
                                                                                                      }, "3"),
                                                                                                  JsxRuntime.jsx("option", {
                                                                                                        children: "NA",
                                                                                                        selected: "na" === x.sentiment,
                                                                                                        value: "na"
                                                                                                      }, "4")
                                                                                                ],
                                                                                                className: "border\n                                      border-gray-400 shade w-full",
                                                                                                placeholder: "Select Sentiment",
                                                                                                value: x.sentiment === "-" ? "Select Sentiment" : x.sentiment,
                                                                                                onChange: (function (param) {
                                                                                                    var sentiment = Utils$ReactHooksTemplate.formTargetValue(param);
                                                                                                    var newCategoryReport = setSentiment(sentiment, x);
                                                                                                    var newCategoryReportList = List.map((function (x$1) {
                                                                                                            if (x$1.id === x.id) {
                                                                                                              return newCategoryReport;
                                                                                                            } else {
                                                                                                              return x$1;
                                                                                                            }
                                                                                                          }), state.categoryReport);
                                                                                                    return Curry._1(setState, (function (state) {
                                                                                                                  return {
                                                                                                                          loading: state.loading,
                                                                                                                          filter: state.filter,
                                                                                                                          editCategory: state.editCategory,
                                                                                                                          categoryReport: newCategoryReportList,
                                                                                                                          total: state.total,
                                                                                                                          perPage: state.perPage
                                                                                                                        };
                                                                                                                }));
                                                                                                  })
                                                                                              }) : JsxRuntime.jsx("p", {
                                                                                                children: x.sentiment
                                                                                              })
                                                                                      ) : JsxRuntime.jsx("p", {
                                                                                            children: x.sentiment,
                                                                                            className: "capitalize"
                                                                                          }),
                                                                                    className: "w-full"
                                                                                  }),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: $$Array.of_list(Belt_List.mapWithIndex(x.categories, (function (idx, y) {
                                                                                          var categoryReport = state.editCategory;
                                                                                          return JsxRuntime.jsxs("div", {
                                                                                                      children: [
                                                                                                        JsxRuntime.jsx("p", {
                                                                                                              children: String(idx + 1 | 0) + " : ",
                                                                                                              className: "font-medium"
                                                                                                            }),
                                                                                                        categoryReport !== undefined ? (
                                                                                                            categoryReport.id === x.id ? JsxRuntime.jsxs("select", {
                                                                                                                    children: [
                                                                                                                      JsxRuntime.jsx("option", {
                                                                                                                            children: "Select Category",
                                                                                                                            disabled: true,
                                                                                                                            value: "Select Category"
                                                                                                                          }, "0"),
                                                                                                                      $$Array.of_list(Belt_List.mapWithIndex(categoryList, (function (id, category) {
                                                                                                                                  return JsxRuntime.jsx("option", {
                                                                                                                                              children: category,
                                                                                                                                              selected: category === y,
                                                                                                                                              value: category
                                                                                                                                            }, String(id + 1 | 0));
                                                                                                                                })))
                                                                                                                    ],
                                                                                                                    className: "border\n                                      border-gray-400\n                                      shade w-5/6",
                                                                                                                    placeholder: "Select Category",
                                                                                                                    value: y === "-" ? "Select Category" : y,
                                                                                                                    onChange: (function (param) {
                                                                                                                        var value = Utils$ReactHooksTemplate.formTargetValue(param);
                                                                                                                        var newCategories = Belt_List.mapWithIndex(x.categories, (function (idx$1, x) {
                                                                                                                                if (idx$1 === idx) {
                                                                                                                                  return value;
                                                                                                                                } else {
                                                                                                                                  return x;
                                                                                                                                }
                                                                                                                              }));
                                                                                                                        var newCategoryReport = setCategories(newCategories, x);
                                                                                                                        var newCategoryReportList = List.map((function (x$1) {
                                                                                                                                if (x$1.id === x.id) {
                                                                                                                                  return newCategoryReport;
                                                                                                                                } else {
                                                                                                                                  return x$1;
                                                                                                                                }
                                                                                                                              }), state.categoryReport);
                                                                                                                        return Curry._1(setState, (function (state) {
                                                                                                                                      return {
                                                                                                                                              loading: state.loading,
                                                                                                                                              filter: state.filter,
                                                                                                                                              editCategory: state.editCategory,
                                                                                                                                              categoryReport: newCategoryReportList,
                                                                                                                                              total: state.total,
                                                                                                                                              perPage: state.perPage
                                                                                                                                            };
                                                                                                                                    }));
                                                                                                                      })
                                                                                                                  }) : JsxRuntime.jsx("p", {
                                                                                                                    children: y,
                                                                                                                    className: "w-5/6"
                                                                                                                  })
                                                                                                          ) : JsxRuntime.jsx("p", {
                                                                                                                children: y
                                                                                                              })
                                                                                                      ],
                                                                                                      className: "flex mb-10-px items-center w-full"
                                                                                                    });
                                                                                        }))),
                                                                              className: "px-4 py-2"
                                                                            }),
                                                                        JsxRuntime.jsx("td", {
                                                                              children: JsxRuntime.jsx("div", {
                                                                                    children: categoryReport$1 !== undefined ? (
                                                                                        categoryReport$1.id === x.id ? JsxRuntime.jsxs("div", {
                                                                                                children: [
                                                                                                  JsxRuntime.jsx("button", {
                                                                                                        children: "Update",
                                                                                                        className: "bg-teal-500 hover:bg-teal-700\n                                    py-6-px px-20-px font-normal text-white\n                                    font-16-px leading-snug mb-10-px",
                                                                                                        style: {
                                                                                                          outline: "None"
                                                                                                        },
                                                                                                        onClick: (function (param) {
                                                                                                            var params = {};
                                                                                                            params["id"] = String(x.id);
                                                                                                            if (x.sentiment !== "-") {
                                                                                                              params["sentiment"] = x.sentiment;
                                                                                                            }
                                                                                                            params["categories"] = Json_encode.list((function (prim) {
                                                                                                                    return prim;
                                                                                                                  }), List.filter(function (x) {
                                                                                                                        return x !== "-";
                                                                                                                      })(x.categories));
                                                                                                            Js_promise.then_((function (param) {
                                                                                                                    var newCategoryReport = setEdited(true, x);
                                                                                                                    var newCategoryReportList = List.map((function (x$1) {
                                                                                                                            if (x$1.id === x.id) {
                                                                                                                              return newCategoryReport;
                                                                                                                            } else {
                                                                                                                              return x$1;
                                                                                                                            }
                                                                                                                          }), state.categoryReport);
                                                                                                                    return Promise.resolve(Curry._1(setState, (function (state) {
                                                                                                                                      return {
                                                                                                                                              loading: state.loading,
                                                                                                                                              filter: state.filter,
                                                                                                                                              editCategory: undefined,
                                                                                                                                              categoryReport: newCategoryReportList,
                                                                                                                                              total: state.total,
                                                                                                                                              perPage: state.perPage
                                                                                                                                            };
                                                                                                                                    })));
                                                                                                                  }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/long_text_responses/update_categories", params));
                                                                                                          })
                                                                                                      }),
                                                                                                  JsxRuntime.jsx("button", {
                                                                                                        children: "cancel",
                                                                                                        className: "hover:text-gray-500 py-6-px\n                                  px-10-px border border-gray-400\n                                  hover:border-gray-300 mr-20-px",
                                                                                                        style: {
                                                                                                          outline: "None",
                                                                                                          outlineStyle: "unset"
                                                                                                        },
                                                                                                        onClick: (function (param) {
                                                                                                            Curry._1(setState, (function (state) {
                                                                                                                    return {
                                                                                                                            loading: state.loading,
                                                                                                                            filter: state.filter,
                                                                                                                            editCategory: undefined,
                                                                                                                            categoryReport: state.categoryReport,
                                                                                                                            total: state.total,
                                                                                                                            perPage: state.perPage
                                                                                                                          };
                                                                                                                  }));
                                                                                                          })
                                                                                                      })
                                                                                                ],
                                                                                                className: "flex flex-col"
                                                                                              }) : JsxRuntime.jsx("div", {
                                                                                                children: JsxRuntime.jsx("button", {
                                                                                                      children: "Edit",
                                                                                                      className: "hover:text-teal-500 py-6-px\n                                  px-10-px border border-gray-400\n                                  hover:border-teal-300 mr-20-px",
                                                                                                      style: {
                                                                                                        outline: "None",
                                                                                                        outlineStyle: "unset"
                                                                                                      },
                                                                                                      onClick: (function (param) {
                                                                                                          Curry._1(setState, (function (state) {
                                                                                                                  return {
                                                                                                                          loading: state.loading,
                                                                                                                          filter: state.filter,
                                                                                                                          editCategory: x,
                                                                                                                          categoryReport: state.categoryReport,
                                                                                                                          total: state.total,
                                                                                                                          perPage: state.perPage
                                                                                                                        };
                                                                                                                }));
                                                                                                        })
                                                                                                    }),
                                                                                                className: "flex items-center"
                                                                                              })
                                                                                      ) : JsxRuntime.jsx("div", {
                                                                                            children: JsxRuntime.jsx("button", {
                                                                                                  children: "Edit",
                                                                                                  className: "hover:text-teal-500 py-6-px px-10-px\n                              border border-gray-400 hover:border-teal-300\n                              mr-20-px",
                                                                                                  style: {
                                                                                                    outline: "None",
                                                                                                    outlineStyle: "unset"
                                                                                                  },
                                                                                                  onClick: (function (param) {
                                                                                                      Curry._1(setState, (function (state) {
                                                                                                              return {
                                                                                                                      loading: state.loading,
                                                                                                                      filter: state.filter,
                                                                                                                      editCategory: x,
                                                                                                                      categoryReport: state.categoryReport,
                                                                                                                      total: state.total,
                                                                                                                      perPage: state.perPage
                                                                                                                    };
                                                                                                            }));
                                                                                                    })
                                                                                                }),
                                                                                            className: "flex items-center"
                                                                                          }),
                                                                                    className: "flex w-full justify-center"
                                                                                  }),
                                                                              className: "px-4 py-2"
                                                                            })
                                                                      ],
                                                                      className: "border-b border-bottom-gray-600"
                                                                    });
                                                        }), state.categoryReport))
                                            })
                                      ],
                                      className: "text-left table-auto w-full border-separate text-xs font-medium"
                                    }),
                                className: "flex items-center px-30-px"
                              })
                        ]
                      })
                ]
              });
  }
}

var make = CategoryEdit;

exports.categoryList = categoryList;
exports.CategoryReport = CategoryReport;
exports.initialState = initialState;
exports.make = make;
/* react Not a pure module */
